<template>
    <div>
      <el-row>
            <el-col :span="12">
                <div class="grid-content title">{{ title }}</div>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="6">
                <div class="grid-content spent">Витрачено: {{ spent_amount | numberify}}</div>
            </el-col>
            <el-col :span="10" :offset="8">
                <div class="grid-content left">Залишилося: {{ amount_left | numberify }} / {{ planned_amount | numberify }}</div>
            </el-col>
        </el-row>
        <el-row>
            <el-col>
                <el-progress :percentage="percentage" :show-text="false" :color="customColors"></el-progress>
            </el-col>
        </el-row>
    </div>
</template>
<script>
export default {
    props: ['title', 'spent_amount', 'planned_amount'],
    data: () => ({
        customColors: [
          {color: '#5cb87a', percentage: 60},
          {color: '#e6a23c', percentage: 80},
          {color: '#f56c6c', percentage: 90}
        ]
    }),
    computed: {
        percentage: function () {
            return this.spent_amount / this.planned_amount * 100.0
        },
        amount_left: function () {
            return this.planned_amount - this.spent_amount
        }
    },
    filters: {
        numberify: function (value) {
            if (!value) return '0'
            return new Intl.NumberFormat().format(Math.trunc(value))
        }
    }
}
</script>
<style scoped>
  .el-row {
    margin-bottom: 5px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    background: #d3dce6;
  }
  .bg-purple-light {
    background: #e5e9f2;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 10px;
  }
  .row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
  }
  .title {
    text-align: left;
    font-size: 20px;
    padding-bottom: 5px;
  }
  .spent {
    text-align: left;
  }
  .left {
    text-align: right;
  }
</style>